import toast from "react-hot-toast";

const Password = ({
  setIsShowPromptReAuthFor,
  isUpdatedPassword,
  setIsUpdatedPassword,
  newPasswordValueRef,
}) => {
  return (
    <>
      {isUpdatedPassword && (
        <>
          <div className="fixed top-[35%] md:left-[35%] left-[5%] right-[5%] md:w-[500px] max-w-[90vw] min-h-[150px] px-5 py-4 z-40 bg-dark-lighten rounded-md shadow-md">
            <p className="text-white text-lg text-center">
              Updating password successfully
            </p>
            <div className="flex gap-5 mt-8 justify-end">
              <button
                onClick={() => setIsUpdatedPassword(false)}
                className="px-4 py-2 rounded-full bg-dark-lighten-2 text-white hover:bg-white hover:text-dark-darken transition duration-300"
              >
                OK
              </button>
            </div>
          </div>
          <div
            onClick={() => setIsUpdatedPassword(false)}
            className="fixed top-0 left-0 w-full h-full z-[5] bg-black/60"
          ></div>
        </>
      )}
      <div className="mt-10 max-w-[600px]">
        <p className="text-white text-lg font-medium mb-3">Change password</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!newPasswordValueRef.current.value.trim().length) {
              toast("Please type a new secure password!", {
                icon: "✍️",
              });
              return;
            }
            setIsShowPromptReAuthFor("password");
          }}
          className="flex justify-between gap-14 md:gap-28 items-center"
        >
          <div className="flex-1">
            <input
              ref={newPasswordValueRef}
              type="password"
              className="bg-dark-lighten py-3 rounded-md  outline-none px-5 text-white w-full"
              placeholder="New password"
            />
          </div>
          <button className="px-6 py-4 bg-dark-lighten rounded-xl text-white hover:bg-white hover:text-dark-darken transition duration-300">
            Update
          </button>
        </form>
      </div>
    </>
  );
};

export default Password;
